














































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { PaymentTypesDTO, ShipmentDTO } from "@/model/data.model";
import { isItaly } from "@/services/Helpers";
import { Validations } from "vuelidate-property-decorators";
import { minValue, required } from "vuelidate/lib/validators";
import { AlertBus } from "@/plugins/alerts/AlertBus";

@Component({})
export default class ExtraServiceDetail extends Vue {
  @Prop() service_name: string;
  @Prop() title: string;
  @Prop() is_selected: boolean;
  @Prop() has_value: boolean;
  @Prop() has_description: boolean;
  @Prop() has_payment_type: boolean;
  @Prop() edition: boolean;
  @Prop() value: string;
  @Prop() value_label: string;
  @Prop() description: string;
  @Prop() description_label: string;
  @Prop() default_payment_types: PaymentTypesDTO[];
  @Prop() payment_types: PaymentTypesDTO[];
  @Prop() payment_type: PaymentTypesDTO;
  @Prop() payment_type_label: string;
  @Prop() idMbeBusiness: number;
  @Prop() insuranceConflict: boolean;
  @Prop() ship_and_pack_included: boolean;
  @Prop() shipment: ShipmentDTO;
  @Prop() sv4bMin: number;
  @Prop() sv4bMax: number;
  @Prop() sv4bCoverage: boolean;
  @Prop() isSafeValueSelected: boolean;

  shipAndPack = false;

  @Validations()
  validations() {
    if (this.is_selected) {
      return {
        value: this.has_value ? { required, minValue: minValue(0.1) } : {},
        payment_type: this.has_payment_type
          ? {
              extraServicePaymentTypeId: required
            }
          : {}
      };
    }
    return {};
  }
  created() {
    this.shipAndPack =
      this.ship_and_pack_included !== undefined
        ? this.ship_and_pack_included
        : this.sv4bCoverage;
  }
  isShipAndPackDisabled() {
    return !this.is_selected || !this.edition;
  }

  formatDecimal(value) {
    if (isNaN(value) || value === "") {
      value = "0.00";
    }
    if (isItaly()) {
      return String(value).replace(".", ",");
    }
    return value;
  }

  toggleService() {
    this.$emit("toggle", this.service_name);
  }

  toggleShipAndPack() {
    this.$emit("toggleShipAndPack");
  }

  @Watch("is_selected")
  onSelectedChange(selected: boolean) {
    if (!selected) {
      // reset on select false
      if (this.has_value) {
        this.value = "0.00";
      }
      if (this.has_payment_type) {
        this.payment_type = null;
      }
      if (this.ship_and_pack_included) {
        this.ship_and_pack_included = null;
      }
    }
  }

  showAlertToggle() {
    if (this.insuranceConflict) {
      const message = this.$t("INSURANCE_CONFLICT");
      AlertBus.$alerts.danger(message);
    }
  }

  @Watch("ship_and_pack_included")
  watched() {
    this.shipAndPack = this.ship_and_pack_included;
  }

  @Watch("shipment.courierId")
  onChangeCourier() {
    if (this.service_name == "Cash on Delivery") {
      this.$emit("resetPaymentType");
    }
  }
}
